import { Col, Row, Typography } from 'antd';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { Card } from 'src/components/Card/Card';
import { DataView } from 'src/components/DataView/DataView';
import { Empty } from 'src/components/Empty/Empty';
import { ListPage } from 'src/components/FormPages/ListPage';
import { PartnerLoanApplicationStatusView } from 'src/components/PartnerLoanApplicationStatusView/PartnerLoanApplicationStatusView';
import { EntityLinks } from 'src/core/router/EntityLinks';
import { Router } from 'src/core/router/Router';
import { LoanApplicationDto } from 'src/generated-api-client';
import { AgentLoanApplicationsStore } from 'src/stores/AgentLoanApplicationsStore/AgentLoanApplicationsStore';
import { Entity } from 'src/utils/mobx/BasicStore/BasicStore.types';

export const AgentLoanApplicationsPage = observer(() => {
    return (
        <ListPage
            pageName="agent-loan-applications"
            store={AgentLoanApplicationsStore}
            header={
                <Row gutter={16}>
                    <Col flex={1}>
                        <Typography.Title level={3}>
                            {t('Agent.Applications.Title')}
                        </Typography.Title>
                    </Col>
                </Row>
            }
            empty={<Empty description={t('Agent.Applications.Empty')} />}
            renderItem={(item: Entity) => {
                const application = item as unknown as LoanApplicationDto;

                return (
                    <Card
                        key={application.id}
                        onClick={() => {
                            const path =
                                application.id !== undefined
                                    ? EntityLinks.loanApplications.itemDetails?.(
                                          application.id,
                                      )
                                    : undefined;

                            if (path) {
                                Router.navigate(path);
                            }
                        }}
                    >
                        <Row gutter={[16, 16]}>
                            <Col xs={24} sm={5}>
                                <DataView
                                    label={t(
                                        'Agent.Applications.ApplicationID',
                                    )}
                                    value={application.number}
                                />
                            </Col>
                            <Col xs={24} sm={5}>
                                <DataView
                                    label={t('Agent.Applications.MerchantName')}
                                    value={application.merchant?.name}
                                />
                            </Col>
                            <Col xs={24} sm={5}>
                                <DataView
                                    label={t('Agent.Applications.CreationDate')}
                                    value={application.createdAt}
                                    formatValue="dateTimeSeconds"
                                />
                            </Col>
                            <Col xs={24} sm={5}>
                                <DataView
                                    label={t('Agent.Applications.Status')}
                                    value={
                                        <PartnerLoanApplicationStatusView
                                            status={application.status}
                                        />
                                    }
                                />
                            </Col>
                            <Col xs={24} sm={4}>
                                <DataView
                                    label={t('Agent.Applications.Amount')}
                                    value={
                                        application.finalOffer?.financingAmount
                                    }
                                    formatValue="currency-sar"
                                />
                            </Col>
                        </Row>
                    </Card>
                );
            }}
        />
    );
});
